import request from './index'

// ===== 申请类型 =====
export function getTypeList(params) {
  return request({ url: '/approval/types', method: 'get', params })
}
export function getTypeOptions() {
  return request({ url: '/approval/types/options', method: 'get' })
}
export function createType(data) {
  return request({ url: '/approval/types', method: 'post', data })
}
export function updateType(id, data) {
  return request({ url: '/approval/types/' + id, method: 'put', data })
}
export function deleteType(id) {
  return request({ url: '/approval/types/' + id, method: 'delete' })
}

// ===== 审批流 =====
export function getFlowList(params) {
  return request({ url: '/approval/flows', method: 'get', params })
}
export function createFlow(data) {
  return request({ url: '/approval/flows', method: 'post', data })
}
export function updateFlow(id, data) {
  return request({ url: '/approval/flows/' + id, method: 'put', data })
}
export function deleteFlow(id) {
  return request({ url: '/approval/flows/' + id, method: 'delete' })
}
// 员工端：按类型取可绑定审批流
export function getFlowOptions(type) {
  return request({ url: '/approval/flows/options/' + type, method: 'get' })
}

// ===== 申请 =====
export function submitRequest(data) {
  return request({ url: '/approval/requests', method: 'post', data })
}
export function getMyRequests(params) {
  return request({ url: '/approval/requests/my', method: 'get', params })
}
export function getMyTasks(params) {
  return request({ url: '/approval/requests/my/tasks', method: 'get', params })
}
export function getRequestDetail(id) {
  return request({ url: '/approval/requests/' + id, method: 'get' })
}
export function approveRequest(id, taskId, data) {
  return request({ url: `/approval/requests/${id}/task/${taskId}/approve`, method: 'post', data })
}
export function rejectRequest(id, taskId, data) {
  return request({ url: `/approval/requests/${id}/task/${taskId}/reject`, method: 'post', data })
}
export function cancelRequest(id) {
  return request({ url: `/approval/requests/${id}/cancel`, method: 'post' })
}
export function submitDraftRequest(id, data) {
  return request({ url: `/approval/requests/${id}/submit`, method: 'post', data })
}
export function updateDraftRequest(id, data) {
  return request({ url: `/approval/requests/${id}`, method: 'put', data })
}
export function deleteRequest(id) {
  return request({ url: `/approval/requests/${id}`, method: 'delete' })
}
// 审批统计（员工维度汇总，默认当月，仅已通过）
export function getApprovalStats(params) {
  return request({ url: '/approval/requests/stats', method: 'get', params })
}
// 已审核通过的报销单列表（报销支出录入）
export function getApprovedReimburseList(params) {
  return request({ url: '/approval/requests/reimburse-list', method: 'get', params })
}
// 申请人下拉选项（申请过的员工去重名单）
export function getApplicantOptions() {
  return request({ url: '/approval/requests/applicant-options', method: 'get' })
}
// 考勤同步统计（工资表制作：按月份汇总已通过的请假天数/加班时长，扣除调休抵扣部分）
export function getAttendanceSummary(params) {
  return request({ url: '/approval/requests/attendance-summary', method: 'get', params })
}
export function uploadApprovalFile(file) {
  const formData = new FormData()
  formData.append('file', file)
  return request({ url: '/approval/requests/upload', method: 'post', data: formData })
}

// ===== 调休余额 =====
export function getCompBalance() {
  return request({ url: '/approval/comp/balance', method: 'get' })
}
export function getMyCompTxs(params) {
  return request({ url: '/approval/comp/my', method: 'get', params })
}
export function getCompSummary(params) {
  return request({ url: '/approval/comp/summary', method: 'get', params })
}
export function getUserCompTxs(userId, params) {
  return request({ url: `/approval/comp/user/${userId}`, method: 'get', params })
}

// ===== 假期额度 =====
// 员工端：启用假种 + 本人当年余额
export function getLeaveOptions() {
  return request({ url: '/approval/leave/options', method: 'get' })
}
// 员工端：各请假日期的工作时长（上午/下午/全天分钟数，用于请假时长折算）
export function getWorkTimeSlots(dates) {
  return request({ url: '/work-time/slots', method: 'get', params: { dates: (dates || []).join(',') } })
}
// 管理端：假期规则
export function getLeaveRules() {
  return request({ url: '/approval/leave/rules', method: 'get' })
}
export function updateLeaveRule(id, data) {
  return request({ url: `/approval/leave/rules/${id}`, method: 'put', data })
}
// 管理端：员工余额列表与调整
export function getLeaveBalances(params) {
  return request({ url: '/approval/leave/balances', method: 'get', params })
}
export function updateLeaveBalance(id, data) {
  return request({ url: `/approval/leave/balances/${id}`, method: 'put', data })
}